import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef
} from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import { SafeHtml } from '@angular/platform-browser';
import { ControlValidationService } from '../control-validation.service';

@Component({
  selector: 'portal-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {
  @Input() form: FormGroup = new FormGroup({});
  @Input() controlName: string;
  @Input() type = 'text';
  @Input() value: any = null;
  @Input() readonly: boolean;
  @Input() icon: string;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() hintStart: string | SafeHtml;
  @Input() hintEnd: string | SafeHtml;
  @Input() prefix: string | SafeHtml;
  @Input() suffix: string | SafeHtml;
  @Input() customErrors: { [key: string]: any };
  @Output() inputSubmit: EventEmitter<any> = new EventEmitter();
  @Output() inputChanges: EventEmitter<any> = new EventEmitter();
  control: AbstractControl;
  isRequired: boolean;
  errorList: { [key: string]: any };

  constructor(
    private controlValidationService: ControlValidationService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (this.controlName) {
      this.control = this.form.get(this.controlName);
      if (this.control.errors) {
        this.isRequired = this.control.errors.required && true;
      }
    }
    /*
      Force change detection, need it to avoid 
      "Expression has changed after it was checked" on conditional inputs
    */
    this.cdRef.detectChanges();
  }

  empty() {
    if (!this.value) {
      this.inputSubmit.emit(this.value);
    }
  }

  submit(): void {
    this.inputSubmit.emit(this.value);
  }

  changes(): void {
    this.inputChanges.emit(this.value);
  }

  errors(control: AbstractControl): string {
    const { errors } = control;
    if (errors) {
      const inputName = this.label || this.controlName;
      this.errorList = this.controlValidationService.commonErrors(
        this.control,
        inputName
      );
      if (this.customErrors) {
        this.errorList = { ...this.errorList, ...this.customErrors };
      }

      return this.errorList[Object.keys(errors)[0]];
    }
  }
}
